// extracted by mini-css-extract-plugin
module.exports = {"bigAvatar":"styles_bigAvatar__BKQAB","input":"styles_input__4jR2i","box":"styles_box__Ciq9r","icon":"styles_icon__QJphK"};